<template>
  <DsProcessSection
    title=""
    title-id="tu-construye-process-title"
    intro="Para tu comodidad, hemos dividido el proceso en etapas claras:"
    layout="grid"
    :columns="3"
    card-variant="responsive"
    :steps="steps"
  >
    <template #title><span>Tu proceso</span> <span class="hl">paso a paso</span></template>
    <template #step-1
      ><p>Reunimos lo básico para iniciar tu expediente:</p>
      <ul>
        <li>Escrituras</li>
        <li>Predial</li>
        <li>Recibo de agua</li>
        <li>Pago del avalúo</li>
        <li>Comprobante de que tu terreno está libre de gravamen.</li>
      </ul></template
    >
    <template #step-2
      ><p>Preparamos la escrituración con:</p>
      <ul>
        <li>Avalúo del terreno,</li>
        <li>Tu licencia de construcción</li>
        <li>Presupuesto de obra.</li>
      </ul></template
    >
    <template #step-3
      ><p>Conforme avanzas, liberamos el capital:</p>
      <ul>
        <li>Cimentación</li>
        <li>Estructura y Techado</li>
        <li>Acabados</li>
        <li>Terminación</li>
      </ul></template
    >
  </DsProcessSection>
</template>
<script setup lang="ts">
import DsProcessSection from '../components/DsProcessSection.vue'
const steps = [
  {
    id: '1',
    title: 'Integración'
  },
  {
    id: '2',
    title: 'Formalización'
  },
  {
    id: '3',
    title: 'Ministraciones y Construcción'
  }
]
</script>
